// extracted by mini-css-extract-plugin
export default {"wrapper-div":"Profile_wrapper-div__T2jBt"};